export const COMPANY_TEXT = `Depuis 1975, la société BELVILUS est au service des Guadeloupéens et de
la Caraibe.`